import { Link, GatsbyLinkProps } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { localizePath } = require("../config/localizePath");

// TZ-684 -- a drop-in replacement for gatsby's <Link> that keeps the reader in
// the language they are already reading.
//
// The language comes from i18n.language rather than from `location`, because
// I18nProvider sets it synchronously before render (see its comment about the
// hydration mismatch). That makes it correct during SSR and available at any
// depth without threading `location` through the tree.
//
// Untranslated targets stay Polish -- see the comment in config/localizePath.js
// for why that is deliberate and not a shortcut.
// `ref` is omitted deliberately. GatsbyLinkProps types it for HTMLAnchorElement,
// but gatsby's Link is a class component whose ref is Link<TState> -- spreading
// one into the other is a type error. Nothing in this repository would catch it
// (there is no tsconfig.json and Gatsby strips types with babel, unchecked), so
// it would sit here silently until someone added a type-check step. No caller
// passes a ref to a link today.
const LocalizedLink = <TState,>({
  to,
  ...rest
}: Omit<GatsbyLinkProps<TState>, "ref">): JSX.Element => {
  const { i18n } = useTranslation();

  return <Link to={localizePath(to, i18n.language)} {...rest} />;
};

export default LocalizedLink;
